<p-blockUI [blocked]="telaBloqueada">
    <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)"
        animationDuration=".5s"></p-progressSpinner>
</p-blockUI>